import React from 'react'
import PropTypes from 'prop-types'
import { RadioGroup as BaseRadioGroup, Radio } from '@maui/elements'

export const RadioGroup = ({ value, onChange, items, inputProps, ...props }) => {
  const handleChange = (e) => {
    onChange(e.target.value)
  }

  return (
    <BaseRadioGroup value={value} onChange={handleChange} {...props}>
      {
        items.map((item, index) => (
          <Radio
            key={index}
            value={item.value}
            name={item.name || item.value || item.label || index}
            {...inputProps}
          >
            { item.label }
          </Radio>
        ))
      }
    </BaseRadioGroup>
  )
}

RadioGroup.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
  onChange: PropTypes.func,
  value: PropTypes.string,
  inputProps: PropTypes.object,
}
